import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { style: {"text-align":"center","margin-bottom":"1.5rem","margin-top":"1rem"} }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h4", { style: {"text-align":"center","font-weight":"bold","text-transform":"uppercase","margin-bottom":"8px"} }, " Biên bản giải thể ", -1)
const _hoisted_3 = { style: {"text-align":"center","margin-bottom":"4px","font-style":"italic"} }
const _hoisted_4 = { style: {"text-align":"center","margin-bottom":"0"} }
const _hoisted_5 = { style: {"display":"flex","flex-direction":"row","margin-bottom":"1rem"} }
const _hoisted_6 = { style: {"flex":"0 0 50%"} }
const _hoisted_7 = { style: {"margin-bottom":"4px"} }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("strong", null, "Tên thiết bị:", -1)
const _hoisted_9 = { style: {"margin-bottom":"0"} }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("strong", null, "Dạng sửa chữa:", -1)
const _hoisted_11 = { style: {"flex":"0 0 50%"} }
const _hoisted_12 = { style: {"margin-bottom":"4px"} }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("strong", null, "Số hiệu (số toa xe):", -1)
const _hoisted_14 = { style: {"margin-bottom":"0"} }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("strong", null, "Ngày vào xưởng:", -1)
const _hoisted_16 = { style: {"margin-bottom":"4px","font-weight":"bold"} }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("strong", null, "Vật tư trong định mức:", -1)
const _hoisted_18 = {
  key: 0,
  class: "pdf-print-table",
  style: {"font-size":"0.8rem","margin-bottom":"1rem"}
}
const _hoisted_19 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { style: {"width":"30px"} }, "TT"),
    /*#__PURE__*/_createElementVNode("th", { style: {"width":"300px"} }, "Tên vật tư"),
    /*#__PURE__*/_createElementVNode("th", { style: {"width":"70px"} }, "Mã vật tư"),
    /*#__PURE__*/_createElementVNode("th", { style: {"width":"90px"} }, "Đơn vị tính"),
    /*#__PURE__*/_createElementVNode("th", { style: {"width":"70px"} }, "Số lượng"),
    /*#__PURE__*/_createElementVNode("th", null, "Ghi chú")
  ])
], -1)
const _hoisted_20 = { style: {"text-align":"left"} }
const _hoisted_21 = { style: {"text-align":"left"} }
const _hoisted_22 = { style: {"text-align":"right"} }
const _hoisted_23 = { style: {"text-align":"left"} }
const _hoisted_24 = { style: {"margin-bottom":"4px","font-weight":"bold"} }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("strong", null, "Vật tư ngoài định mức:", -1)
const _hoisted_26 = {
  key: 1,
  class: "pdf-print-table",
  style: {"font-size":"0.8rem","margin-bottom":"2rem"}
}
const _hoisted_27 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { style: {"width":"30px"} }, "TT"),
    /*#__PURE__*/_createElementVNode("th", { style: {"width":"300px"} }, "Tên vật tư"),
    /*#__PURE__*/_createElementVNode("th", { style: {"width":"70px"} }, "Mã vật tư"),
    /*#__PURE__*/_createElementVNode("th", { style: {"width":"90px"} }, "Đơn vị tính"),
    /*#__PURE__*/_createElementVNode("th", { style: {"width":"70px"} }, "Số lượng"),
    /*#__PURE__*/_createElementVNode("th", null, "Ghi chú")
  ])
], -1)
const _hoisted_28 = { style: {"text-align":"left"} }
const _hoisted_29 = { style: {"text-align":"left"} }
const _hoisted_30 = { style: {"text-align":"right"} }
const _hoisted_31 = { style: {"text-align":"left"} }
const _hoisted_32 = {
  "data-pdf-keep-together": "",
  style: {"display":"flex","justify-content":"space-around","margin-top":"2rem"}
}
const _hoisted_33 = { style: {"text-align":"center","font-weight":"bold","margin":"0 0 4px","font-size":"0.7rem"} }
const _hoisted_34 = /*#__PURE__*/_createElementVNode("p", { style: {"text-align":"center","margin":"0","font-size":"0.7rem"} }, " (Ký, họ tên) ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PdfDocumentHeader = _resolveComponent("PdfDocumentHeader")!
  const _component_PdfViewerPage = _resolveComponent("PdfViewerPage")!

  return (_openBlock(), _createBlock(_component_PdfViewerPage, {
    title: "Biên bản giải thể",
    "title-suffix": _ctx.bienBanData?.so_bien_ban,
    source: _ctx.pdfSource,
    "file-name": _ctx.pdfFileName,
    loading: _ctx.isGenerating,
    "fallback-route-name": "danh-sach-bien-ban-giai-the"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", {
        ref: "printArea",
        class: "bien-ban-giai-the-viewer__hidden-template",
        style: _normalizeStyle(_ctx.hiddenTemplateStyle),
        "aria-hidden": "true"
      }, [
        (_ctx.bienBanData)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "printing-paper",
              style: _normalizeStyle(_ctx.printPaperStyle)
            }, [
              _createVNode(_component_PdfDocumentHeader, {
                "ten-don-vi": _ctx.tenDonVi,
                "ten-don-vi-cha": _ctx.tenDonViCha,
                "show-national-motto": true
              }, null, 8, ["ten-don-vi", "ten-don-vi-cha"]),
              _createElementVNode("div", _hoisted_1, [
                _hoisted_2,
                _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.ngayBienBanDisplay), 1),
                _createElementVNode("p", _hoisted_4, [
                  _createElementVNode("strong", null, "Số: " + _toDisplayString(_ctx.bienBanData.so_bien_ban), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("p", _hoisted_7, [
                    _hoisted_8,
                    _createTextVNode(" " + _toDisplayString(_ctx.bienBanData.toa_xe.ten_toa_xe), 1)
                  ]),
                  _createElementVNode("p", _hoisted_9, [
                    _hoisted_10,
                    _createTextVNode(" " + _toDisplayString(_ctx.capSuaChuaDisplay), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("p", _hoisted_12, [
                    _hoisted_13,
                    _createTextVNode(" " + _toDisplayString(_ctx.bienBanData.toa_xe.so_hieu), 1)
                  ]),
                  _createElementVNode("p", _hoisted_14, [
                    _hoisted_15,
                    _createTextVNode(" " + _toDisplayString(_ctx.ngayVaoXuongDisplay), 1)
                  ])
                ])
              ]),
              _createElementVNode("p", _hoisted_16, [
                _hoisted_17,
                _createTextVNode(" " + _toDisplayString(!_ctx.vatTuDmcdItems.length ? "Không có" : ""), 1)
              ]),
              (_ctx.vatTuDmcdItems.length)
                ? (_openBlock(), _createElementBlock("table", _hoisted_18, [
                    _hoisted_19,
                    _createElementVNode("tbody", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.vatTuDmcdItems, (vatTu, index) => {
                        return (_openBlock(), _createElementBlock("tr", {
                          key: index,
                          class: _normalizeClass({
                'pdf-print-table-data-row': true,
                'pdf-print-table-data-row--last':
                  index === _ctx.vatTuDmcdItems.length - 1,
              })
                        }, [
                          _createElementVNode("td", null, _toDisplayString(index + 1), 1),
                          _createElementVNode("td", _hoisted_20, _toDisplayString(vatTu.ten_vat_tu), 1),
                          _createElementVNode("td", _hoisted_21, _toDisplayString(vatTu.ma_vat_tu), 1),
                          _createElementVNode("td", null, _toDisplayString(vatTu.don_vi_tinh || "-"), 1),
                          _createElementVNode("td", _hoisted_22, _toDisplayString(_ctx.formatQuantity(vatTu.pivot.so_luong)), 1),
                          _createElementVNode("td", _hoisted_23, _toDisplayString(_ctx.getVatTuGhiChu(vatTu)), 1)
                        ], 2))
                      }), 128))
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("p", _hoisted_24, [
                _hoisted_25,
                _createTextVNode(" " + _toDisplayString(!_ctx.bienBanData.ngoai_dinh_muc.length ? "Không có" : ""), 1)
              ]),
              (_ctx.bienBanData.ngoai_dinh_muc.length)
                ? (_openBlock(), _createElementBlock("table", _hoisted_26, [
                    _hoisted_27,
                    _createElementVNode("tbody", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.bienBanData.ngoai_dinh_muc, (vatTu, index) => {
                        return (_openBlock(), _createElementBlock("tr", {
                          key: index,
                          class: _normalizeClass({
                'pdf-print-table-data-row': true,
                'pdf-print-table-data-row--last':
                  index === _ctx.bienBanData.ngoai_dinh_muc.length - 1,
              })
                        }, [
                          _createElementVNode("td", null, _toDisplayString(index + 1), 1),
                          _createElementVNode("td", _hoisted_28, _toDisplayString(vatTu.ten_vat_tu), 1),
                          _createElementVNode("td", _hoisted_29, _toDisplayString(vatTu.ma_vat_tu), 1),
                          _createElementVNode("td", null, _toDisplayString(vatTu.don_vi_tinh || "-"), 1),
                          _createElementVNode("td", _hoisted_30, _toDisplayString(_ctx.formatQuantity(vatTu.pivot.so_luong)), 1),
                          _createElementVNode("td", _hoisted_31, _toDisplayString(_ctx.getVatTuGhiChu(vatTu)), 1)
                        ], 2))
                      }), 128))
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_32, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.signatureItems, (sig) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: sig.label,
                    style: {"display":"inline-flex","flex-direction":"column","align-items":"center","justify-content":"space-between","height":"120px","flex":"1"}
                  }, [
                    _createElementVNode("div", null, [
                      _createElementVNode("p", _hoisted_33, _toDisplayString(sig.label), 1),
                      _hoisted_34
                    ])
                  ]))
                }), 128))
              ])
            ], 4))
          : _createCommentVNode("", true)
      ], 4)
    ]),
    _: 1
  }, 8, ["title-suffix", "source", "file-name", "loading"]))
}